export const MoneyBackStatusEnum = {
    PENDING: 'pending',
    PAID: 'paid',
    DECLINED: 'declined',
};
